import { Value, Block, Text } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
import generateBlockId from '../../utils/generateBlockId';
export default function makeDefaultPlainTextDeserializer(editor) {
  return {
    canDeserialize: function canDeserialize(_ref) {
      var type = _ref.type,
          text = _ref.text;
      return type === 'text' && text.length;
    },
    deserialize: function deserialize(_ref2) {
      var text = _ref2.text;

      if (text.includes('\n')) {
        var blocks = text.split('\n').map(function (line) {
          return Block.create({
            type: BlockTypes.UNSTYLED,
            nodes: [Text.create({
              text: line
            })],
            data: {
              id: generateBlockId()
            }
          });
        });
        return Value.create({
          document: {
            nodes: blocks
          }
        });
      }

      return Value.create({
        document: {
          nodes: [Block.create({
            type: BlockTypes.UNSTYLED,
            nodes: [Text.create({
              text: text
            })],
            data: {
              id: generateBlockId()
            }
          })]
        }
      });
    }
  };
}